import { StaticImage } from 'gatsby-plugin-image'
import React from 'react'
import * as Styles from './contact-page-title.module.scss'
import { PageTitle } from '@/components/general/page-title'

export function ContactPageTitle({
  title,
  en,
  readText,
  decorationLogo = true,
  ...props
}) {
  return (
    <PageTitle
      title={title}
      en={en}
      decorationLogo={decorationLogo}
      readText={readText}
      {...props}
    >
      <div className={Styles.pageTitle_decoration_1}>
        <StaticImage src="../../images/page-title_image_contact.png" height={165} />
      </div>
    </PageTitle>
  )
}
